import { defineStore } from 'pinia'

export const useGlobalStore = defineStore('global', {
  state: () =>
    ({
      isMobile: false,
      isTablet: false,
    }) as {
      isMobile: boolean
      isTablet: boolean
    },
})
